//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data () {
        return {
            index: 0
        };
    },

    computed: {
        planets () {
            return this.$store.getters.planets.map(planet => ({
                name: planet.name[this.$lang.locale],
                badges: this.$store.getters.badges.filter(badge => badge.week === planet.week)
            }));
        },
        activePlanet () {
            return this.planets[this.index];
        }
    }
};
